<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content fxLayout="column" fxLayoutAlign="space-between stretch">

  @if (!isLoaded) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (isLoaded) {
    @if (isAPPayable) {
      <ap-payable-detail [detail]="detail">
      </ap-payable-detail>
    }
    @if (isAPPayment) {
      <ap-payment-detail [detail]="detail">
      </ap-payment-detail>
    }
    @if (isPOReceipt) {
      <po-receipt-detail [detail]="detail">
      </po-receipt-detail>
    }
    @if (isGLJournalEntry) {
      <gl-journal-entry-detail [detail]="detail">
      </gl-journal-entry-detail>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (cardActions.length > 0) {
    @for (action of cardActions; track action) {
      <button mat-button [mat-dialog-close]="action" [matTooltip]="action.label" class="noMinWidth" [attr.aria-label]="getActionAriaLabel(action)" [attr.telemetry]="getActionAriaLabel(action)">
        <mat-icon [ngStyle]="getActionStyle(action)">
          {{action.icon}}
        </mat-icon>
      </button>
    }
  }

  <button mat-button mat-dialog-close [attr.telemetry]="getCloseActionAriaLabel()">
    Close
  </button>
</mat-dialog-actions>